import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/Profile.module.css';
import { isAuthenticated } from '../api/auth';
import { trackUnsubscribe } from '../utils/analytics';
import UnsubscribeModal from './Modals/UnsubscribeModal';
import ArrowLeft from '../static/img/backArrow.png'
import PremiumPackagePopup from "../components/PremiumPackagePopup";

import userIcon from '../static/img/icons/user.png';
import lockIcon from '../static/img/icons/lock.png';
import bellIcon from '../static/img/icons/bell.png';
import diamondIcon from '../static/img/icons/diamond.png';
import giftIcon from '../static/img/icons/gift.png';
import helpIcon from '../static/img/icons/help.png';
import privacyIcon from '../static/img/icons/privacy.png';
import termsIcon from '../static/img/icons/terms.png';
import unsubscribeIcon from '../static/img/icons/unsubscribe.png';
import logoutIcon from '../static/img/icons/logout.png';
const Profile = ({ isJcUser }) => {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    const [showUnsubModal, setShowUnsubModal] = useState(false);
    useEffect(() => {
        document.title = "Settings | Jazz ESL";
        if (!isAuthenticated()) {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
    }, []);
    const [showPremiumPopup, setShowPremiumPopup] = useState(false);


    const handleLogout = () => {
        const refferer = sessionStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
        if (refferer === "gamenow") return;

        sessionStorage.clear();
        window.location.href = process.env.REACT_APP_LOGIN_URL;
    };

    // const handleUnsub = () => {
    //     const refferer = sessionStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
    //     if (refferer === "gamenow") return;

    //     trackUnsubscribe('intent_to_unsub');
    //     navigate("/unsubscribe");
    // };
    const handleUnsub = () => {
        const refferer = sessionStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
        if (refferer === "gamenow") return;

        trackUnsubscribe('intent_to_unsub');
        setShowUnsubModal(true); // open modal
    };

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>user</p>
                    <h2 className={styles.heading}>settings</h2>
                </div>
            </div>

            {/* PROFILE CARD */}
            {/* <div className={styles.profileCard}>
                <div className={styles.avatar}>U</div>
                <div className={styles.profileInfo}>
                    <div className={styles.name}>Usama Khan</div>
                    <div className={styles.username}>@usama_85854 · Premium</div>
                </div>
                <div className={styles.arrow}>›</div>
            </div> */}

            {/* ACCOUNT */}
            <div className={styles.sectionTitle}>ACCOUNT</div>
            <div className={styles.card}>
                <div className={styles.item} onClick={() => navigate('/edit-profile')}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.blue}`}>
                            <img src={userIcon} alt="" />
                        </div>
                        <span>Edit Profile</span>
                    </div>
                    <span>›</span>
                </div>

                {/* <div className={styles.item} onClick={() => navigate('/permissions')}>
                    <div className={styles.left} >
                        <div className={`${styles.iconBox} ${styles.purple}`}>
                            <img src={lockIcon} alt="" />
                        </div>
                        <span>Privacy & Security</span>
                    </div>
                    <span>›</span>
                </div> */}

                <div className={styles.item} onClick={() => navigate('/notifications')}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.yellow}`}>
                            <img src={bellIcon} alt="" />
                        </div>
                        <span>Notifications</span>
                    </div>
                    <div className={styles.rightText}>
                        {/* <span className={styles.unread}>5 unread</span> */}
                        <span>›</span>
                    </div>
                </div>
            </div>

            {/* PREMIUM */}
            <div className={styles.sectionTitle}>PREMIUM</div>
            <div className={styles.card} >
                <div className={styles.item}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.cyan}`}>
                            <img src={diamondIcon} alt="" />
                        </div>
                        <span>Subscription</span>
                    </div>

                    {isJcUser ? (
                        <button className={styles.upgradeButton} >Premium Plan</button>
                    ) : (
                        <button className={styles.upgradeButton} onClick={() => { 
                            setShowPremiumPopup(true);
                        }}>Basic . Upgrate to premium</button>
                    )}
                </div>

                <div className={styles.item} onClick={() => navigate('/rewards')}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.green}`}>
                            <img src={giftIcon} alt="" />
                        </div>
                        <span>Rewards & Gifts</span>
                    </div>
                    <span>›</span>
                </div>
            </div>

            {/* SUPPORT */}
            <div className={styles.sectionTitle}>SUPPORT</div>
            <div className={styles.card}>
                <div className={styles.item} onClick={() => navigate('/faqs')}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.red}`}>
                            <img src={helpIcon} alt="" />
                        </div>
                        <span>Help & FAQs</span>
                    </div>
                    <span>›</span>
                </div>

                <div className={styles.item} onClick={() => navigate('/terms-service')}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.gray}`}>
                            <img src={privacyIcon} alt="" />
                        </div>
                        <span>Privacy Policy</span>
                    </div>
                    <span>›</span>
                </div>

                {/* <div className={styles.item}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.gray}`}>
                            <img src={termsIcon} alt="" />
                        </div>
                        <span>Terms of Service</span>
                    </div>
                    <span>›</span>
                </div> */}
            </div>

            {/* ACTIONS */}
            <div className={styles.card}>
                <div className={styles.item} onClick={handleUnsub}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.red}`}>
                            <img src={unsubscribeIcon} alt="" />
                        </div>
                        <span>Unsubscribe</span>
                    </div>
                    <span>›</span>
                </div>

                <div className={styles.item} onClick={handleLogout}>
                    <div className={styles.left}>
                        <div className={`${styles.iconBox} ${styles.red}`}>
                            <img src={logoutIcon} alt="" />
                        </div>
                        <span>Logout</span>
                    </div>
                    <span>›</span>

                </div>
            </div>
            <UnsubscribeModal
                isOpen={showUnsubModal}
                onClose={() => setShowUnsubModal(false)}
                onConfirm={() => {
                    setShowUnsubModal(false);
                    navigate("/unsubscribe");
                }}
            />
            <PremiumPackagePopup
                isOpen={showPremiumPopup}
                onClose={() => setShowPremiumPopup(false)}
            />
        </div>
    );
};

export default Profile;